module.exports = __webpack_public_path__ + "static/media/CloudSun04d.2fa23d8f.png";